<template>
  <div class="tests">
    <div v-loading="loading" class="tests__list">
      <div v-if="clusters.length === 0">
        <span class="tests__no-test"> {{ $t('children.noTestsPerformed') }}</span>
      </div>
      <el-select
        v-model="selectedClusterName"
        placeholder="Select cluster"
        popper-class="w-100"
        class="w-100 tests__list-select"
      >
        <el-option v-for="cluster in clusters" :key="cluster.name" :label="cluster.name" :value="cluster.name">
          <span style="float: left;">{{ cluster.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 9px;"
            >{{ cluster.tests[0].grade_name }} / {{ cluster.tests[0].subject_name | deleteNumbers }} -
            {{ cluster.tests[0].started_date | getDate }}</span
          >
        </el-option>
      </el-select>
      <ul class="tests__list-display">
        <li
          v-for="cluster in clusters"
          :key="cluster.name"
          :class="[
            'tests__list-display-item',
            { 'tests__list-display-item--active': selectedClusterName === cluster.name },
          ]"
          @click="selectedClusterName = cluster.name"
        >
          <span style="font-size: 13pt;">{{ cluster.name }}</span>
          <span style="color: #8492a6; font-size: 11px; text-align: end;"
            >{{ cluster.tests[0].grade_name }} / {{ cluster.tests[0].subject_name | deleteNumbers }} -
            {{ cluster.tests[0].started_date | getDate }}</span
          >
        </li>
      </ul>
    </div>
    <div :class="['test__preview', { 'test__preview--bg-image': selectedClusterName === null }]">
      <Swiper ref="mySwiper" :options="swiperOptions" :auto-update="true">
        <h2 v-if="selectedClusterName === null" class="unselected-test">{{ $t('children.noTestSelected') }}</h2>
        <SwiperSlide v-for="(test, index) in tests" :key="test.id">
          <h3 class="test__grade-name">
            {{ $t('singup.grade') }}: <span>{{ test.grade_name }}</span>
          </h3>
          <h3 class="test__subject-name">
            {{ $t('resultBoardTest.subject') }}
            <span>{{ test.subject_name | deleteNumbers }}</span>
          </h3>
          <h3 class="test__cluster-name">
            {{ $t('resultBoardTest.cluster') }}
            <span>{{ test.cluster_name }}</span>
          </h3>
          <h3 class="test__attempt">
            {{ $t('resultBoardTest.attempt') }} {{ (index - tests.length) * -1 }} /
            {{ tests.length }}
          </h3>
          <h3 class="test__score">{{ $t('resultBoardTest.qualification') }} {{ test.average | evaluateByLetters }}</h3>
          <ul class="test__details">
            <li class="test__details-item">
              <span>{{ $t('resultBoardTest.qualification') }}</span>
              {{ test.correct_answers === 10 ? 100 : test.average }}%
            </li>
            <li class="test__details-item">
              <span>{{ $t('resultBoardTest.correctAnswers') }}</span> {{ test.correct_answers }}
            </li>
            <li class="test__details-item">
              <span>{{ $t('resultBoardTest.incorrectAnswers') }}</span> {{ test.incorrect_answers }}
            </li>
            <li class="test__details-item">
              <span>{{ $t('resultBoardTest.start') }}</span>
              {{ test.started_date | englishDateNew }}
              <!-- {{ test.finish_date }} {{ test.started_date }} -->
            </li>
            <li class="test__details-item">
              <span>{{ $t('resultBoardTest.timeUsed') }}</span>
              {{ test | getTimeUsed | formatDurationTest }}
            </li>
          </ul>
        </SwiperSlide>
        <img
          slot="button-prev"
          class="swiper-button-prev d-none d-sm-block"
          src="@/assets/carousel/Asset_28.png"
          alt
          height="58"
          width="21"
        />
        <img
          slot="button-next"
          class="swiper-button-next d-none d-sm-block"
          src="@/assets/carousel/Asset_28_right.png"
          alt
          height="58"
          width="21"
        />
      </Swiper>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import _ from 'lodash';
import moment from 'moment';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  filters: {
    getDate: function (date) {
      return moment(date).format('LL');
    },
    getTimeUsed: function (test) {
      var startedDate = moment(test.started_date);
      var endedDate = moment(test.finish_date);
      return endedDate.diff(startedDate);
    },
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      clusters: [],
      selectedClusterName: null,
      swiperOptions: {
        keyboard: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 'auto',
          },
        },
      },
    };
  },
  computed: {
    tests() {
      return _.find(this.clusters, ['name', this.selectedClusterName])
        ? _.find(this.clusters, ['name', this.selectedClusterName]).tests
        : [];
    },
  },
  created() {
    this.fetchTest();
  },
  methods: {
    fetchTest() {
      this.loading = true;
      this.$httpMain
        .get(`tests/${this.studentId}`)
        .then(res => {
          this.clusters = _.chain(res.data)
            // Group the elements of Array based on `cluster_name` property
            .groupBy('cluster_name')
            // `key` is group's name (cluster name), `value` is the array of objects
            .map((value, key) => ({ name: key, tests: value }))
            .value();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // getTest(test) {
    //   this.clusterSeleted = test;
    // },
  },
};
</script>
<style lang="sass" scoped>
.tests
  display: flex
  flex-wrap: wrap
  height: 100%
  padding-left: .5em
  padding-right: .5em
  +element('no-test')
    color: blue
  +element('list')
    height: 55px
    width: 100%
    +forTablet
      height: 100%
      overflow-y: auto
      width: 40%
      box-shadow: 2px -1px 5px 1px rgba(150,145,150,1)
      padding: 1em
      border-radius: 5px
  +element('list-select')
    +forTablet
      display: none
  +element('list-display')
    display: none
    +forTablet
      display: block
  +element('list-display-item')
    display: flex
    align-items: center
    justify-content: space-between
    padding: .5em 0
    cursor: pointer
    &:hover
      border: 1px solid #429999
      border-radius: 5px
    +modifier('active')
      border: 1px solid #429999
      border-radius: 5px

.test__preview
  height: 100%
  width: 100%
  +modifier('bg-image')
    +forTablet
      background-image: url('~@/assets/images/icon-tpm.png')
      background-position: cover
      background-repeat: no-repeat
      background-size: cover
  +forTablet
    width: 60%
.unselected-test
  text-align: center
  width: 100%
  font-size: 18px
  +forTablet
    font-size: 32px
.test
  +element('preview')
    //height: calc(100% - 55px)
  +element('grade-name')
    font-size: 14px
    font-family: 'comfortaabold'
    margin-bottom: .5em
    span
      font-family: 'comfortaaregular'
  +element('subject-name')
    font-size: 14px
    font-family: 'comfortaabold'
    margin-bottom: .5em
    span
      font-family: 'comfortaaregular'
  +element('cluster-name')
    font-size: 14px
    font-family: 'comfortaabold'
    margin-bottom: .5em
    span
      font-family: 'comfortaaregular'
  +element('cluster-name')
    font-size: 14px
    font-family: 'comfortaabold'
    margin-bottom: .5em
    span
      font-family: 'comfortaaregular'
  +element('attempt')
    color: #429999
    font-size: 14px
    margin-bottom: .5em
  +element('score')
    color: #429999
    font-size: 14px
    font-family: 'comfortaabold'
  +element('details')
    padding: 1em 0em
  +element('details-item')
    font-family: 'comfortaabold'
    font-size: 16px
    line-height: 2.5
    // padding: 1em 0
    display: flex
    &:first-child
      color: #afbb49
    span
      border-right: 3px solid #429999
      min-width: 160px
      margin-right: .5em

.swiper-container
  height: 100%

.swiper-slide
  width: 96%
  border: 2px solid #7f7f7f
  border-radius: 35px
  margin: 0 3.1em //0 .1em
  padding: 1em
  +forTablet
    width: 85%

//landscape phone
@media (max-height: 500px)
  .swiper-slide
    border-radius: 0px
    overflow-y: auto
// @media (max-width: 576px)
//   .test
//   +element('preview')
//     //height: calc(100% - 55px)
//   +element('grade-name')
//     font-size: 14px
//     font-family: 'comfortaabold'
//     margin-bottom: .5em
//     span
//       font-family: 'comfortaaregular'
//   +element('subject-name')
//     font-size: 14px
//     font-family: 'comfortaabold'
//     margin-bottom: .5em
//     span
//       font-family: 'comfortaaregular'
//   +element('cluster-name')
//     font-size: 14px
//     font-family: 'comfortaabold'
//     margin-bottom: .5em
//     span
//       font-family: 'comfortaaregular'
//   +element('cluster-name')
//     font-size: 14px
//     font-family: 'comfortaabold'
//     margin-bottom: .5em
//     span
//       font-family: 'comfortaaregular'
//   +element('attempt')
//     color: #429999
//     font-size: 14px
//     margin-bottom: .5em
//   +element('score')
//     color: #429999
//     font-size: 14px
//     font-family: 'comfortaabold'
//   +element('details')
//     padding: 1em 0em
//   +element('details-item')
//     font-family: 'comfortaabold'
//     font-size: 16px
//     line-height: 2.5
//     // padding: 1em 0
//     display: flex
//     &:first-child
//       color: #afbb49
//     span
//       border-right: 3px solid #429999
//       min-width: 160px
//       margin-right: .5em

// .tests {
//   display: flex;
//   flex-wrap: wrap;
//   align-items: center;
//   .list {
//     height: 100%;
//     width: 48%;
//     padding: 15px;
//     overflow: auto;
//     margin-right: 10px;
//     &::-webkit-scrollbar {
//       width: 8px;
//       border-radius: 10px;
//       background: rgba($color: #93dfdf, $alpha: 0.4);
//     }
//     &::-webkit-scrollbar-thumb {
//       border-radius: 10px;
//       background: #429999;
//     }
//     .test-link {
//       display: block;
//       padding: 4px;
//       border-radius: 5px;
//       &:hover {
//         cursor: pointer;
//         background-color: rgba($color: #ced529, $alpha: 0.5);
//       }
//     }
//     .date-of-cluster {
//       float: right;
//     }
//   }
//   .details {
//     height: 100%;
//     width: 50%;
//     padding: 0 30px;
//     border-left: 3px solid #c3cfd9;
//     .VueCarousel {
//       height: 100%;
//       border: 2px solid #7f7f7f;
//       border-radius: 35px;
//       // padding: 30px;
//       // display: flex;
//       // align-items: center;
//       .VueCarousel-wrapper {
//         .test-not-selected {
//           display: flex;
//           align-items: center;
//           height: 500px;
//           width: 500px;
//           margin: 0 auto;
//           img {
//             height: 500px;
//             width: 500px;
//             opacity: 0.1;
//             position: absolute;
//             z-index: 1;
//           }
//           h1 {
//             z-index: 2;
//             text-align: center;
//             margin: 0 15px;
//             font-weight: bold;
//           }
//         }
//         .VueCarousel-slide {
//           padding: 1em;
//         }
//       }
//     }
//     .test-titles {
//       h1 {
//         font-size: 18px;
//         font-family: 'comfortaabold';
//         span {
//           font-family: 'comfortaaregular';
//         }
//       }
//     }
//     .test-attempt {
//       margin-top: 1em;
//       margin-bottom: 1em;
//       color: #429999;
//       .attempt {
//         font-size: 16px;
//       }
//       .qualification {
//         font-family: 'comfortaabold';
//         font-size: 18px;
//       }
//     }
//     .test-details {
//       padding: 10px;
//       margin: 0 auto;
//       width: 450px;
//       h1 {
//         &:first-child {
//           color: #afbb49;
//         }
//         font-family: 'comfortaabold';
//         font-size: 18px;
//         margin-bottom: 0;
//         span {
//           padding: 10px;
//           margin-right: 45px;
//           display: inline-block;
//           width: 260px;
//           border-right: 3px solid #429999;
//         }
//       }
//     }
//   }
// }
// .not-history {
//   background-color: #fff;
//   width: 100%;
//   display: block;
//   text-align: center;
// }
</style>
